import * as _ from 'underscore';
import { Dictionary } from '../../type_definitions/vendor';

/**
 * @ngdoc object
 * @name _global.object:DomUtil
 * @description A set of DOM related utilities
 *
 */

export class DomUtil {

  public static FRAME_TOP:string = 'topFrame';
  public static FRAME_CONTENT:string = 'content';
  public static FRAME_MENU:string = 'menu';

  /**
   * @ngdoc function
   * @name _global.object:DomUtil#measureText
   * @methodOf _global.object:DomUtil
   *
   * @description Measures a piece of HTML text by injecting it into an invisible element
   *
   * @param {string} innerHtml       Some (HTML) text that needs to be measured.
   * @param {string} className  The CSS class name to use for the invisible elements.
   * @param {Object} cssProperties   The css properties that need to be set on the text.
   * @returns {number} The measured width in number of pixels (might be rounded depending on the browser).
   */
  public static measureText(innerHtml:string, className:string, cssProperties:Dictionary<string>):number {
    let fakeEl = $(`.${className}`);
    if (!fakeEl.length) {
      fakeEl = $(`<span class="${className}">`).hide();
      _.forEach(cssProperties, (value, propertyName) => {
        fakeEl.css(propertyName, value);
      });
      fakeEl.appendTo($('body'));
    }

    return fakeEl.html(innerHtml).width();
  }

  public static isVerticalScrollbarVisible(element:HTMLElement):boolean {
    return element.scrollHeight > element.clientHeight;
  }

  public static getFrameTop():Window {
    return DomUtil.getFrame(DomUtil.FRAME_TOP);
  }

  public static getFrameContent() {
    return DomUtil.getFrame(DomUtil.FRAME_CONTENT);
  }

  public static getFrameMenu() {
    return DomUtil.getFrame(DomUtil.FRAME_MENU);
  }

  public static getFrame(id):Window {
    const frame = DomUtil.findFrame(window, id);
    return frame? frame : DomUtil.findFrame(parent, id);
  }

  private static findFrame(aWindow, id) {
    try {
      //check if aWindow itself corresponds with the frame
      const frameElement = aWindow.frameElement;
      if (frameElement && frameElement.id === id) {
        return aWindow;
      }
    } catch (e) {
      // cross-origin exceptions can occur
      // do nothing
    }
    const frames = aWindow.frames;

    for (let i = 0; i < frames.length; i++) {
      try {
        if (frames[ i ].frameElement.id === id) {
          return frames[ i ];
        }
      } catch (e) {
        // cross-origin exceptions can occur
        // do nothing
      }

    }
  }
}